import React from 'react';
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book2/2-1.jpg';
import b2 from '../img/book2/2-2.jpg';
import b3 from '../img/book2/2-3.jpg';
import b4 from '../img/book2/2-4.jpg';
import b5 from '../img/book2/2-5.jpg';
import b6 from '../img/book2/2-6.jpg';
import b7 from '../img/book2/2-7.jpg';
import b8 from '../img/book2/2-8.jpg';
import b9 from '../img/book2/2-9.jpg';
import b10 from '../img/book2/2-10.jpg';
import b11 from '../img/book2/2-11.jpg';
import b12 from '../img/book2/2-12.jpg';
const Books2 = () => {
  return (
    <>
      <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
        {/* ---------------------book1--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              borderColor="lightgray"
              bg={'#fff'}
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>أطلس متململا - الجزء الأول</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span> خالد حافظي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>آين راند </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>الآن باديو على لسان الآن باديو </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>فتحي المسكيني </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span> الان باديو</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة </span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              bg={'#fff'}
              borderRadius="10px"
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>السطحيون </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>وفاء م. يوسف </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>نيكولاس كار </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book2--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span> العلوم العربية في عصرها الذهبي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>محمد نعيم </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>أحمد جبار</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار: &nbsp;
                      <span>صفحة سبعة </span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان: &nbsp;
                      <span> الغريزة اللغوية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>الطيب الحصني </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span> ستيفن بنكر </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>هل تحتاج المرأة المسلمة إلى إنقاذ؟ </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span> د. محمد الرحموني</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>ليلى أبو لغد </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book3--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>دروس قرن من الحياة </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span> خليد كدري</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>إدغار موران </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>عبقرية الكذب</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>إياد عيسى </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>فرانسوا نودلمان </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span> صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span> عقل فوق العقل</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>عمر فايد </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>كريس بيرديك </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book4--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>الظافرات </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>فائزة بودبوس </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span> ليتيسيا كولومباني</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>حروب المعنى </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الألمانية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span> فتحي المسكيني</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>
                        مارتن هيدغر - كارل سميث - حنا آرندت - ريتشارد رورتي -
                        يورغن هابراماس - بيتر سلوتردايك - والتر د. ميلو
                      </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span> صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                        height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span> نيتشه والحلقة المفرغة  </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span> صلاح بن عياد </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span> بيير كلوسوفسكي  </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text  color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
      </VStack>
    </>
  );
};

export default Books2;
